<template>

  <div class="container tes-2column-layout tes-page-container tes-page-container_simple">

    <section class="tes-2column-layout__content tes-page tes-page_simple">

      <BreadcrumbsView class="tes-blog__nav-info_left-direction tes-blog__nav-info_slash-divider"
                       :pagination="null"
                       :items="breadcrumbs"/>


      <PageEmptyView v-if="!page.id()"/>
      <PageView :page="page" v-else/>

      <div class="tes-article__social-panel">

        <ObserverComponent>
          <div class="tes-article__ratings-container">
            <span class="tes-article__ratings-header">Рейтинг страницы</span>
            <PostRating :item="page" ownerType="page" :k="String('page_' + page.id())"/>
          </div>

          <div class="tes-article__socials-share-container">
            <span class="tes-article__socials-share-header">Поделиться</span>
            <PostSocialShare :nets="['vk']" :item="page"/>
          </div>
        </ObserverComponent>

      </div>

      <Suspense>
        <template #default>
          <CommentListView ownerType="page" :initialCount="page.countComments()" :ownerId="page.id()"/>
        </template>
        <template #fallback>
          <EllipsisLoader :loading="true" class="tes-loader__overlay_inner"/>
        </template>
      </Suspense>

    </section>

    <aside class="tes-2column-layout__aside">

      <ObserverComponent>
        <Suspense>
          <template #default>
            <AsideMenu :menuTid="page.subMenuTid()" v-once/>
          </template>
          <template #fallback>
            <EllipsisLoader :loading="true" class="tes-loader__overlay_inner"/>
          </template>
        </Suspense>
      </ObserverComponent>

      <ObserverComponent>
        <Suspense>
          <template #default>
            <PostAsideListView v-once/>
          </template>
          <template #fallback>
            <EllipsisLoader :loading="true" class="tes-loader__overlay_inner"/>
          </template>
        </Suspense>

        <Suspense>
          <template #default>
            <BannerAsideListView v-once/>
          </template>
          <template #fallback>
            <EllipsisLoader :loading="true" class="tes-loader__overlay_inner"/>
          </template>
        </Suspense>
      </ObserverComponent>

    </aside>

  </div>

</template>

<script lang="ts">

import {pageHeadersStateSymbol, PageHeadsStore, prepareHead} from "../states/page-heads";
import {Breadcrumbs} from "../objects/Breadcrumb";
import {Page, PageData, PageInterface, pageEmptyData} from "../objects/Page";
import {Loader, loaderStateSymbol} from "../states/loader";
import {defineAsyncComponent, inject, onMounted, onServerPrefetch, Ref, ref, watch} from "vue";
import {Router, useRouter} from "vue-router";

import PageView from '../components/page/PageView.vue'
import PageEmptyView from '../components/page/PageEmptyView.vue'

import BreadcrumbsView from '../components/BreadcrumbsView.vue'
import EllipsisLoader from '../components/loader/EllipsisLoader.vue'
import PostRating from "../components/post/PostRating.vue";
import PostSocialShare from "../components/post/PostSocialShare.vue";
import MailSubscriptionBlogForm from "../components/form/MailSubscriptionBlogForm.vue";
import {useStore} from "vuex";


export default {
  name: 'SimplePage',
  components: {
    BreadcrumbsView,
    PageView,
    PageEmptyView,
    PostRating,
    PostSocialShare,
    MailSubscriptionBlogForm,
    CommentListView: defineAsyncComponent({
      loader: () => import('~/components/comment/CommentListView.vue'),
      delay: 500,
      timeout: 1000
    }),
    EllipsisLoader,
    PostAsideListView: defineAsyncComponent({
      loader: () => import('~/components/post/PostAsideListView.vue'),
      delay: 650,
      timeout: 1000
    }),
    //AsideMenu,
    AsideMenu: defineAsyncComponent({
      loader: () => import('~/components/menu/AsideMenu.vue'),
      delay: 350,
      timeout: 1000
    }),
    BannerAsideListView: defineAsyncComponent({
      loader: () => import('~/components/banner/BannerAsideListView.vue'),
      delay: 1000,
      timeout: 1000
    }),
  },
  props: {
    path: {
      type: String,
      required: true
    }
  },
  async setup(props) {

    const store = useStore()
    const router: Router = useRouter()
    const loading: Loader | undefined = inject(loaderStateSymbol)
    const head: PageHeadsStore | undefined = inject(pageHeadersStateSymbol)

    const page: Ref<PageInterface> = ref(new Page(pageEmptyData))

    const breadcrumbs = ref(new Breadcrumbs([]))

    const load = () => {
      loading?.start()
      page.value = new Page(pageEmptyData)
      breadcrumbs.value = new Breadcrumbs([])

      return store.dispatch('pages/loadDataForPage',{path: props.path, options: null}, { root: true })
        .then((data) => {
          try {
            page.value = new Page(data as PageData)
            breadcrumbs.value = page.value.breadcrumbs()
            let h = prepareHead(page.value.heads())
            if (head) {
              head.updateHead(h)
            }
          } catch (e) {
            console.log(e)
            router.push({name: 'ServerError', params: {number: 3}});
          }
        })
        .catch(error => {
          if (error.status === 404) {
            router.push({name: 'NotFound'});
          } else if (error.status >= 500) {
            router.push({name: 'ServerError', params: {number: (error.status - 500)}});
          }
        })
        .finally(() => loading?.stop())
    }

    watch(() => props.path, () => {
      load()
    })

    onMounted(() => {
      load()
    })

    onServerPrefetch(() => {
      return load()
    })

    return {page, breadcrumbs}
  }
}
</script>

<style src="~/styles/post-page.scss"/>
